/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type RiskSpanRedacted = {
  /**
   * The message field this span matched (see RiskSpan.field).
   */
  field?: string | undefined;
  /**
   * Opaque fingerprint of this span's match, in the same form as RiskResultRedacted.match_redacted.
   */
  matchRedacted: string;
  /**
   * The JSON sub-path within the field for a `.get(...)` match (see RiskSpan.path).
   */
  path?: string | undefined;
  /**
   * Whether this span carried byte-position information.
   */
  positionKnown: boolean;
};

/** @internal */
export const RiskSpanRedacted$inboundSchema: z.ZodMiniType<
  RiskSpanRedacted,
  unknown
> = z.pipe(
  z.object({
    field: z.optional(z.string()),
    match_redacted: z.string(),
    path: z.optional(z.string()),
    position_known: z.boolean(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "match_redacted": "matchRedacted",
      "position_known": "positionKnown",
    });
  }),
);

export function riskSpanRedactedFromJSON(
  jsonString: string,
): SafeParseResult<RiskSpanRedacted, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RiskSpanRedacted$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RiskSpanRedacted' from JSON`,
  );
}
